import React from 'react';
import { withRouter } from "react-router-dom";
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const MessageModal = ({ 
        showInfo, 
        toggle, 
        modalBody, 
        modalFooterButtons, 
        className, 
        backdrop, 
        showModalHeader, 
        contentClassName, 
    }) => {
    return (
        <Modal isOpen={showInfo} toggle={toggle} centered className={`message-modal ${className}`} contentClassName={contentClassName} backdrop={backdrop ? backdrop : "static"}>
            {showModalHeader && <ModalHeader toggle={toggle} />}
            <ModalBody>
                <div className="row">
                    <div className="col-12">
                        {modalBody}
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                {modalFooterButtons && modalFooterButtons.length >= 1 && modalFooterButtons.map((button, index) => (
                    <button className="btn text-btn" key={index} onClick={button.handleClick}>{button.label}</button>
                ))}
            </ModalFooter>
        </Modal>
    );
}

export default withRouter(MessageModal);